import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Result } from "antd";
import { LockOutlined } from "@ant-design/icons";

const UnauthorizedPage: React.FC = () => {
  const location = useLocation();
  const requestedPath = location.state?.from?.pathname || "Unknown";

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-50 px-4">
      <div className="w-full max-w-lg bg-white rounded-lg shadow-lg p-8 border border-gray-100">
        <Result
          status="403"
          title="Access Denied"
          icon={<LockOutlined className="text-primary text-5xl" />}
          subTitle={
            <div className="space-y-4 mt-4">
              <p className="text-gray-600">
                You don't have permission to access this page. Please contact
                your administrator if you believe this is an error.
              </p>

              <div className="bg-gray-50 border border-gray-200 rounded-md p-3">
                <p className="text-gray-500 text-sm font-medium">
                  Request Information
                </p>
                <p className="text-gray-800 mt-1 font-mono text-xs break-all">
                  {requestedPath}
                </p>
              </div>
            </div>
          }
          extra={[
            <Link key="dashboard" to="/dashboard">
              <Button
                type="primary"
                size="large"
                className="min-w-[160px] bg-primary"
              >
                Go to Dashboard
              </Button>
            </Link>,
            <Button
              key="back"
              onClick={() => window.history.back()}
              size="large"
            >
              Go Back
            </Button>,
          ]}
        />
      </div>
    </div>
  );
};

export default UnauthorizedPage;
